import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import ScrollableDropShadow from '@ui/ScrollableDropShadow.tsx';
import SearchResults from '@ui/SearchResults/SearchResults.tsx';

import RouteUnavailableOptionsWidget from '../RouteUnavailableOptionsWidget.tsx';

const SearchResultsStyled = styled(SearchResults)`
  overflow: auto;
`;

const getDefaultSearch = state => state.defaultSearch;

const getRouteUnavailable = state => state.isRouteUnavailable;
const getEndpointIds = state => state.endpointIds;
const getPoisToAvoid = state => state.poisToAvoid;
const getCurrentInputIndex = state => state.currentInputIndex;

const getPlacesNearby = state => state.searchInputs?.[state.currentInputIndex]?.placesNearby;

const DirectionsSearchView = ({
  handlePoiClicked,
  handleChooseMapLocationClicked,
  widgetState,
  isDesktop,
  handleEscapeKey,
  T,
}) => {
  const [defaultSearch, setDefaultSearch] = useState(getDefaultSearch(widgetState.getState()));
  const [isRouteUnavailable, setIsRouteUnavailable] = useState(getRouteUnavailable(widgetState.getState()));
  const [placesNearby, setPlacesNearby] = useState(getPlacesNearby(widgetState.getState()));
  const [currentInputIndex, setCurrentInputIndex] = useState(getCurrentInputIndex(widgetState.getState()));
  const [endpointIds, setEndpointIds] = useState(getEndpointIds(widgetState.getState()));
  const [poisToAvoid, setPoisToAvoid] = useState(getPoisToAvoid(widgetState.getState()));

  useEffect(() => {
    // Need to re-initialize state when widgetState changes
    const state = widgetState.getState();
    setDefaultSearch(getDefaultSearch(state));
    setIsRouteUnavailable(getRouteUnavailable(state));
    setPlacesNearby(getPlacesNearby(state));
    setCurrentInputIndex(getCurrentInputIndex(state));
    setEndpointIds(getEndpointIds(state));
    setPoisToAvoid(getPoisToAvoid(state));

    // Subscribe to future updates
    return widgetState.addCallback(state => {
      setDefaultSearch(getDefaultSearch(state));
      setIsRouteUnavailable(getRouteUnavailable(state));
      setPlacesNearby(getPlacesNearby(state));
      setCurrentInputIndex(getCurrentInputIndex(state));
      setEndpointIds(getEndpointIds(state));
      setPoisToAvoid(getPoisToAvoid(state));
    });
  }, [widgetState]);

  return isRouteUnavailable ? (
    <RouteUnavailableOptionsWidget T={T} endpointIds={endpointIds} poisToAvoid={poisToAvoid} />
  ) : (
    <ScrollableDropShadow T={T} isDesktop={isDesktop()}>
      <SearchResultsStyled
        defaultSearch={defaultSearch}
        placesNearby={placesNearby}
        currentInputIndex={currentInputIndex}
        onChooseMapLocationClicked={handleChooseMapLocationClicked}
        onPoiClicked={handlePoiClicked}
        isDesktop={isDesktop()}
        handleEscapeKey={handleEscapeKey}
        T={T}
      />
    </ScrollableDropShadow>
  );
};

export default DirectionsSearchView;
